import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Switch
} from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PicturesWall from '../../components/PictureWall/PictureWall';
import { selectName } from '../../slice/agentSlice';
import axiosInstance from '../../util/api';
import './CreateAgentPage.css';
const {  TextArea } = Input;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const CreateAgentPage = () => {
  const [form] = Form.useForm();
  const agentName = useSelector(selectName);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    values.image = image;
    await createAgent(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const createAgent = async (values) => {
    delete values.agent;
    setLoading(true);
    try {
      await axiosInstance.post('/agents', values);
      message.success('Agent successfully created');
      form.resetFields();
    } finally {
      setLoading(false);
    }
  };

  const onPictureUpload = (fileList = []) => {
    const newFileList = fileList.filter((file) => file.status === 'done');
    const pictureList = newFileList.map((file) => file.response.url);
    setImage(pictureList[0]);
  };

  return (
    <div className='create-agent-page-container'>
      <h2>Update Agent</h2>
      <Form
        {...layout}
        name='basic'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className='create-agent-page-form'
        form={form}
      >
        <Form.Item
          label='Name and Surname'
          name='name'
          rules={[
            {
              required: true,
              message: "Please input agents's name and surname!",
            },
            {
              max: 100,
            },
          ]}
        >
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='Residential Address' name='address'>
          <Input />
        </Form.Item>

        <Form.Item label='Contact number' name='mobileNumber'>
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item
          label='Email'
          name='email'
          rules={[
            {
              type: 'email',
            },
          ]}
        >
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='ID / Passport number' name='idNumber'>
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='VAT number' name='vatNumber'>
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='Branch address' name='branchAddress'>
          <Input />
        </Form.Item>

        <Form.Item label='Nationality' name='nationality'>
          <Input style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='Date of birth' name='dateOfBirth'>
          <DatePicker format='DD-MM-YYYY' />
        </Form.Item>

        <Form.Item label='IBAN' name='iban'>
          <Input />
        </Form.Item>

        <Form.Item label='Bank name' name='bankName'>
          <Input />
        </Form.Item>

        <Form.Item label='Swift code' name='swiftCode'>
          <Input />
        </Form.Item>

        <Form.Item label='Title' name='title'>
          <Input />
        </Form.Item>

        <Form.Item label='Description' name='description'>
          <TextArea />
        </Form.Item>

        <Form.Item label='Available on site' name='availableOnSite'>
          <Switch />
        </Form.Item>

        <Form.Item
          label='Username'
          name='username'
          rules={[
            {
              required: true,
              message: "Please input agents's name and surname!",
            },
            {
              max: 100,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label='Password'
          name='password'
          rules={[
            {
              required: true,
              message: "Please input agents's name and surname!",
            },
            {
              max: 100,
              min: 8,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label='Image' name='image'>
          <PicturesWall onPictureUpload={onPictureUpload} />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type='primary' htmlType='submit' disabled={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateAgentPage;
